import BaseMapper from '../../BaseMapper';

const HeaderMapper = (data, context) => {
    return data;
};

export default HeaderMapper;
